import comp from "./MigrationInProgress";
export default comp;
